<!-- 叫价选项卡组件 -->
<template>
  <div v-if="visible">
     <yd-popup class="popupBox" v-model="biddenPopup" position="bottom" :height="biddenData.auctionSessionType == 7?'6.6rem':'6.2rem'" :close-on-masker="false" :masker-opacity="'0.6'">
        <yd-tab v-model="tab" class="biddenTab" active-color="#272727">
            <yd-tab-panel label="委托出价">
                <div class="panel-content">
                  <div class="justify-content" style="padding-top: .3rem;color: #999999;">
                    <span>当前价：{{biddenData.currencySymbol}}{{biddenData.currPrice|| 0 | Bigprice}}</span>
                    <span v-if="biddenData.auctionSessionType == 7">降价幅度： {{biddenData.currencySymbol}}{{jiangjiaStep}}</span>
                    <span v-else>加价幅度：{{biddenData.currencySymbol}}{{jiaJiaStep | Bigprice}}</span>
                  </div>
                  <div class="stepper">
                    <van-stepper v-if="biddenData.auctionSessionType == 7" :value="biddenMax" v-model="biddenMax" integer :min="0" :max="biddenData.currPrice-jiangjiaStep" :step="jiangjiaStep" />
                    <van-stepper v-else v-model="biddenMax" integer :min="xPrice" :step="jiaJiaStep" disable-input />
                    <!-- <span class="price">{{biddenData.currencySymbol}}{{biddenMax}}</span> -->
                  </div>
                  <div style="color: #FA9340;font-size: .24rem;margin-top: .12rem;display: flex;align-items: center;" v-if="biddenData.auctionSessionType == 7"><img src="@/assets/ic_note.png" style="width: .24rem;margin-right: .06rem;"> 拍场结束后统一生成订单再支付</div>
                  <div class="biddenText vertical">
                    <img v-lazy="biddenData.auctionGoodsIcon"><span class="textfir" style="padding-left: .3rem">{{biddenData.auctionGoodsName}}</span>
                  </div>
                </div>
                <template v-if="biddenData.auctionSessionType == 7">
                  <p class="highPrice" v-if="biddenData.userHighestPrice && biddenData.state <= 3 && biddenData.userHighestPrice < Number(biddenData.currPrice)">
                    <span class="highPrice-set">您已设置了委托价{{biddenData.currencySymbol}} <span class="highPrice-mon">{{biddenData.userHighestPrice}}</span>，系统将自动为您出价</span>
                    <span @click="CancellaP" class="highPrice-cancel">取消</span>
                  </p>
                </template>
                <template v-else>
                  <p class="highPrice" v-if="biddenData.userHighestPrice && biddenData.state <= 3 && biddenData.userHighestPrice > Number(biddenData.currPrice)">
                    <span class="highPrice-set">您已设置了委托价{{biddenData.currencySymbol}} <span class="highPrice-mon">{{biddenData.userHighestPrice}}</span>，系统将自动为您出价</span>
                    <span @click="CancellaP" class="highPrice-cancel">取消</span>
                  </p>
                </template>
                <yd-button type="primary" @click.native="postBidden(2)" v-if="!biddenData.state && biddenData.state !== 2" class="biddenBtn">确认</yd-button>
                <yd-button type="primary" @click.native="previewBid" v-else class="biddenBtn fw600">确认</yd-button>
            </yd-tab-panel>

            <yd-tab-panel label="自由出价" v-if="!biddenData.state && biddenData.state !== 2">
              <div class="panel-content">
                <span class="timer-container" v-if="biddenData.auctionSessionType == 7">
                  <skyCountdown :time="biddenData.nextDepreciateTime" timetype="second" :callback="initP">
                    <span class="timeSpan">{%m}'{%s}"</span>后降至￥{{ biddenData.nextDepreciatePrice }}
                  </skyCountdown>
                </span>
                <div class="justify-content" style="padding-top: .5rem;color: #999999;" v-else>
                  <span>当前价：{{biddenData.currencySymbol}}{{biddenData.currPrice|| 0 | Bigprice}}</span>
                  <span>加价幅度：{{biddenData.currencySymbol}}{{jiaJiaStep | Bigprice}}</span>
                </div>
                <div class="stepper" v-if="biddenData.auctionSessionType == 7">
                  <van-stepper v-model="biddenIng" integer :min="fPrice" :step="jiaJiaStep" disable-input disabled  />
                  <span class="price">{{ biddenData.currPrice }}</span>
                </div>
                <div class="stepper" v-else>
                  <van-stepper v-model="biddenIng" integer :value="biddenIng" :min="fPrice" :step="jiaJiaStep" disable-input />
                  <span class="price">{{biddenData.currencySymbol}}{{biddenIng}}</span>
                </div>
                <div style="color: #FA9340;font-size: .24rem;margin-top: .12rem;display: flex;align-items: center;" v-if="biddenData.auctionSessionType == 7"><img src="@/assets/ic_note.png" style="width: .24rem;margin-right: .06rem;"> 拍场结束后统一生成订单再支付</div>
                <div class="biddenText vertical">
                  <img v-lazy="biddenData.auctionGoodsIcon"><span class="textfir" style="padding-left: .3rem">{{biddenData.auctionGoodsName}}</span>
                </div>
              </div>
              <yd-button type="primary" @click.native="postBidden(1)" class="biddenBtn">确认</yd-button>
            </yd-tab-panel>
        </yd-tab>
        <i v-if="tab == 0" class="iconfont icon-wenhao_huabanfuben" @click="maxTip"></i>
        <!--关于弹出框按钮 -->
        <div class="closePopup" @click="closePop">
          <img src="@/assets/closeTab.png" style="width: .6rem;">
        </div>
    </yd-popup>
  </div>
</template>

<script>
import Dialog from '@/utils/mixin/Dialog.js'
export default {
  props: ['biddenData'],
  name: 'BiddenDialog',
  components: {},
  mixins: [Dialog],
  data () {
    return {
      tab: 1,
      biddenMax: 1, // 默认心理出价
      biddenIng: 1, // 默认自由出价,
      xPrice: 0, // 最小默认心理出价
      fPrice: 0, // 最小自由出价
      biddenPopup: false,
      jiaJiaStep: 0,
      jiangjiaStep: 100, // 降价幅度写死 需求是这么定的
    }
  },
  computed: {
  },
  methods: {
    closePop () {
      this.biddenPopup = false
      setTimeout(() => {
        this.visible = false
      }, 100)
    },
    CancellaP () {
      this.$emit('Cancella')
    },
    // 降价倒计时结束 刷新父组件的初始化方法
    initP() {
      this.$emit('initDialog')
      this.biddenPopup = false
    },
    // 自由出价   type==1 自由出价，type==2 设置心理价
    async postBidden (type) {
      let that = this
      let loadinged = this.$layer.loading({className: 'half'})
      let postData, _res
      console.log("==========:" + this.biddenIng)
      if (type == 1) {
        postData = {
          auctionGoodsSeq: this.biddenData.auctionGoodsSeq,
          auctionSessionSeq: this.biddenData.auctionSessionSeq,
          customerSeq: Cookie.get('userSeq'),
          price: this.biddenData.auctionSessionType == 7?this.biddenData.currPrice:this.biddenIng,
          highestPrice: 0,
          signNo: this.biddenData.signNo,
          offerType: 0
        }
      } else {
        postData = {
          auctionGoodsSeq: this.biddenData.auctionGoodsSeq,
          auctionSessionSeq: this.biddenData.auctionSessionSeq,
          customerSeq: Cookie.get('userSeq'),
          price: Number(this.biddenData.currPrice) + this.biddenData.jiaJiaStep,
          highestPrice: this.biddenMax,
          signNo: this.biddenData.signNo,
          offerType: 1
        }
        if (!this.biddenData.priceStepFlag) {
          postData.price = Number(this.biddenData.currPrice) + Number(this.biddenData.jiaJiaStep)
        }
      }
      _res = await this.api.raisePrice(postData)
      if (_res.state == 0) {
        this.$layer.close(loadinged)
        // this.$dialog.toast({
        //   mes: _res.message,
        // });
        return false
      }
      setTimeout(() => {
        this.$emit('myEvent')
        this.closePop()
        if (_res.data == 1) {
          this.$dialog.toast({mes: _res.message, timeout: 1000})
        }
        if (_res.data == 2) {
          this.$layer.alert(_res.message, {title: '', btn: '继续出价'}, () => {
            this.$layer.closeAll()
            this.api.getHighestPrice({
              'auctionGoodsSeq': postData.auctionGoodsSeq,
              'auctionSessionSeq': postData.auctionSessionSeq,
              'customerSeq': Cookie.get('userSeq')
            })
              .then((res) => {
                if (res.state) {
                  this.$createBiddenDialog({
                    $props: {
                      'biddenData': res.data
                    },
                    $events: {
                      myEvent () {
                        that.$emit('updateStatus')
                      }
                    }
                  }, false).show()
                }
              })
          })
        }
        // 出价无效
        if (_res.data == 3) {
          this.$layer.alert(_res.message, {title: '出价无效', btn: '我知道了'})
        }
        this.$layer.close(loadinged)
      }, 1500)
    },
    // 预展中设置委托价
    async previewBid () {
      let postData = {
        auctionGoodsSeq: this.biddenData.auctionGoodsSeq,
        auctionSessionSeq: this.biddenData.auctionSessionSeq,
        price: this.biddenMax
      }
      let _res = await this.api.setProxyPrice(postData)
      if (_res.code === '0000') {
        this.$dialog.toast({
          mes: _res.message
        })
        this.closePop()
        setTimeout(() => {
          this.$emit('myEvent')
        }, 1000)
      }
    },
    maxTip () {
      this.$layer.alert('设置委托价后，若有其他竞拍者对该拍品出价，系统将自动帮您出价，直至当前价达到您设置的委托价，系统将不再帮您出价。拍卖结束后，当前价（高于保留价）是您的出价且未达委托价，则按当前价成交。', {title: '委托出价', btn: '我知道了'})
    }
  },
  mounted () {
    if (this.biddenData.state <= 2) {
      this.tab = 0
    }
    this.jiaJiaStep = Number(this.biddenData.jiaJiaStep)
    let jiaJiaStep = 0
    // 这些傻逼后台的接口，返回来的价格有些是字符串有些是数字
    if (!this.biddenData.priceStepFlag) {
      jiaJiaStep = this.jiaJiaStep
    }
    this.biddenIng = Number(this.biddenData.currPrice)+ jiaJiaStep
    this.fPrice = Number(this.biddenData.currPrice) + jiaJiaStep
    this.biddenMax = this.biddenData.auctionSessionType == 7?(Number(this.biddenData.currPrice) - this.jiangjiaStep):(Number(this.biddenData.currPrice) + this.jiaJiaStep)
    this.xPrice = Number(this.biddenData.currPrice) + this.jiaJiaStep
    console.log(this.biddenIng)
    setTimeout(() => {
      this.biddenPopup = true
    }, 50)
  }
}
</script>
<style>
  .van-stepper__input{
    font-weight: 400 !important;
  }
</style>
<style scoped lang="less">
  .timer-container {
    display: inline-block;
    margin-top: .3rem;
    font-size: .28rem;
    color: #999;
  }
 .popupBox {
  position: relative;
 }
 .highPrice {
    width: 100%;
    height: .56rem;
    line-height: .56rem;
    background: #FFF2E7;
    font-size: 12px;
    color: #FA9340;
    //text-align: center;
    position: fixed;
    left: 0;
    bottom: 1.4rem;
    .highPrice-set{
      margin-left: .2rem;
    }
    .highPrice-mon {
      color: #C93C02;
    }
    .highPrice-cancel{
      position: absolute;
      right: .2rem;
      color: #F46309;
      text-decoration: underline;
    }
  }
 .panel-content {
   background: #FFFFFF;
   box-shadow: 0 0 8px 0 #EEEEEE;
   padding: 0 .32rem;
 }
 .popupBox /deep/ .yd-popup-show{
   border-radius: 8px 8px 0 0;
   overflow: hidden;
 }
 .closePopup {
  position: absolute;
  right: 0;
  top: 0;
  .iconfont {
    font-size: .6rem;
    color: #F2F2F2;
    &:after {
      content: "";
      width: .6rem;
      height: .6rem;
      background: #CCCCCC;
    }
  }
 }
  .stepper {
    position: relative;
    .price {
      position: absolute;
      display: inline-block;
      width: 3.18rem;
      height: 1rem;
      background: #ffffff;
      top: .1rem;
      left: 50%;
      margin-left: -1.59rem;
      text-align: center;
      line-height: 1rem;
      font-size: .44rem;
      color: #C93B00;
    }
  }
  .biddenBtn {
    background: linear-gradient(-134deg, #F46309 0%, #F58F0A 100%);
    border-radius: 4px;
    width: 6.86rem;
    height: .76rem;
    margin: .52rem .32rem;
    padding: 0;
  }
  .icon-wenhao_huabanfuben {
    position: absolute;
    top: .26rem;
    left: .32rem;
    color: #DDDDDD;
    font-size: .4rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/BiddenDialog.vue